import { Box, styled } from '@mui/material';
import iphoneImage from '../../assets/img/iphone_bg.png';

export const IphoneBox = styled(Box)(({ theme }) => ({
    backgroundImage: `url(${iphoneImage})`, 
    backgroundSize: 'contain', 
    backgroundPosition: 'center',
    height: '136px', 
    width: '356px', 
    display: 'flex',
    marginTop: '10px',
    marginLeft:'80px',
    justifyContent: 'center',
    alignItems: 'center',
  }));

export default IphoneBox;